import React from 'react';
import shortid from 'shortid';
import { last } from 'lodash';
import { FormField } from '../form-field';
import FieldNote from '../field-note';

import { REQUIRED } from 'ui/form/constants';
import { FileUploadFieldProps } from 'ui/form/fields';
import { isValue } from 'ui/form/utils';
import Dropzone from 'ui/dropzone';
import { storage } from 'core/firebase';
import { Loader } from 'ui/loader';

export default class FileUpload extends FormField<FileUploadFieldProps> {
  static get defaultValue() {
    return false;
  }

  static getErrors(props, formData): string {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];

    if (props.required && !value) return REQUIRED;
    return false;
  }

  state = {
    uploading: false
  };

  focus = () => {
    if (this.input && !this.state.focus) this.input.focus({ preventScroll: true });
  };

  validate(onlyTouched: boolean) {
    const internalError = FileUpload.getErrors(this.props);
    this.setState({ internalError });
    return !internalError;
  }

  handleDrop = async([file]: File[]) => {
    let filename = shortid.generate() + last(file.name.split('.'));
    this.setState({ uploading: true, internalError: false });
    try {
      const path = (this.props.dir || 'form-upload') + '/' + filename;
      const sFile = storage.ref(path);
      const url = `https://storage.googleapis.com/${sFile.bucket}/${sFile.fullPath}`;
      await sFile.put(file);
      this.props.onChange(url);
      this.setState({ uploading: false });
    } catch (e) {
      console.error('Failed to upload file', e);
      this.setState({ uploading: false, internalError: 'Failed to upload file' });
    }
  };

  render() {
    const { accept, value, error, label, tabIndex, help, className } = this.props;
    const { internalError } = this.state;

    const errorMessage = error || internalError;

    const style = {
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      backgroundImage: value && /(png|jpg|jpeg|gif)/.test(value) ? `url(${value})` : ''
    };

    return (
      <Dropzone
        className={className}
        style={style}
        header={label}
        accept={accept}
        error={errorMessage}
        uploading={this.state.uploading}
        onDrop={this.handleDrop}
      />
    );
  }
}
